import { configureStore } from "@reduxjs/toolkit";

import { routerMiddleware } from "connected-react-router";
import Immutable from "immutable";
import { createLogger } from "redux-logger";
import { persistReducer, persistStore } from "redux-persist";
import immutableTransform from "redux-persist-transform-immutable";
import storage from "redux-persist/es/storage"; // default: localStorage if web, AsyncStorage if react-native
import { createStateSyncMiddleware } from "redux-state-sync";
import history from "./history";
import axiosMiddleware from "./middleware/axios";
import { reducers } from "./reducers/reducers";

const middleWare = [];
middleWare.push(axiosMiddleware); // axios middleware for redux. For requests connected to redux action in api.js files.
middleWare.push(routerMiddleware(history));
middleWare.push(
  createStateSyncMiddleware({
    whitelist: [],
  })
);

const config = {
  transforms: [
    immutableTransform({
      whitelist: ["currentUser", "menu", "cart"], // Store from declared reducers persist until logout that are cleared.
    }),
  ],
  version: "1",
  key: "rootBrewSpecialists",
  whitelist: ["currentUser", "menu", "cart"], // state you want to persist until logout that is cleared.
  // blacklist: [''], // state you do not want to persist
  storage,
  migrate: (state, version) => {
    if (!state) return Promise.resolve(undefined);

    let newState = { ...state };

    // handle menu migration
    if (state.menu) {
      const oldMenu = Immutable.Map.isMap(state.menu)
        ? state.menu.toJS()
        : state.menu;

      newState.menu = Immutable.fromJS({
        openItem: [oldMenu.activeItemId || "group-dashboard"],
        selectedID: oldMenu.activeItemId || "group-dashboard",
        drawerOpen: true,
        selectedItems: "",
        selectedLevel: 0,
        menuItems: oldMenu.menuItems || [],
        menu: {},
      });
    }

    if (state.cart) {
      const oldCart = Array.isArray(state.cart)
        ? state.cart
        : state.cart.cartItems || [];

      newState.cart = {
        cartItems: oldCart,
      };
    }

    return Promise.resolve(newState);
  },
};

// For development environment use redux logger. It displays in console fired actions and store state before and after each action
if (process.env.NODE_ENV === `development`) {
  const logger = createLogger({
    stateTransformer: (state) => {
      let newState = {};
      for (let i of Object.keys(state)) {
        if (Immutable.Iterable.isIterable(state[i])) {
          newState[i] = state[i].toJS();
        } else {
          newState[i] = state[i];
        }
      }
      return newState;
    },
  });
  middleWare.push(logger);
}

const store = configureStore({
  reducer: persistReducer(config, reducers),
  middleware: () => middleWare,
});

export const persistor = persistStore(store);

export default store;
